export default __webpack_public_path__ + "static/media/Imagen_parejas.f90a5737.png";